<template>
  <a-modal
      :title="modeTitle"
      :maskClosable="false"
      :width="640"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @ok="handleSubmit"
      @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 权限名称 -->
      <a-form-item label="权限名称" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
            type="text"
            placeholder="请输入"
            v-decorator="[
            'permName',
            {rules: [{ required: true, message: '请输入权限名称' }]}
          ]"
        />
      </a-form-item>

      <!-- 权限编码-->
      <a-form-item label="权限编码" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
            type="text"
            placeholder="请输入"
            :disabled="inputDisabled"
            v-decorator="[
            'permCode',
            {rules: [{ required: true, message: '请输入权限编码' }]}
          ]"
        />
      </a-form-item>

      <!-- 显示优先级-->
      <a-form-item label="显示优先级" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
            type="text"
            placeholder="请输入"
            v-decorator="[
            'priority',
            {rules: [{ required: true, message: '请输入显示优先级' }],
            initialValue: '0'}
          ]"
        />
      </a-form-item>

      <!--菜单路径-->
      <a-form-item label="菜单路径" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
            type="text"
            placeholder="请输入"
            v-decorator="[
            'path',
            {rules: [{ required: false, message: '请输入菜单路径' }]}
          ]"
        />
      </a-form-item>

      <!-- 选择上级权限-->
      <a-form-item label="上级权限" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-tree-select
            style=""
            :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
            :treeData="allPermissionList"
            placeholder="请选择"
            treeNodeLabelProp="title"
            v-decorator="[
            'key',
            {rules: [{ required: true, message: '请选择上级权限' }]
           }
          ]"
        >
        </a-tree-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
  import permission from "../../api/permission";
  import {analysisAddress} from "../../utils/address";

  export default {
    name: "PermissionFormModal",
    props: [],
    data() {
      return {
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        isAdd: true,
        permissionId: "",
        allPermissionList: [],//下拉选择全部权限的集合
        parentId: null,//上一级的角色id
        modeTitle: '',//弹框的标题
        inputDisabled: false,//输入框是否禁止输入
      };
    },
    methods: {

      //初始化，显示
      init(type, params) {
        this.visible = true;
        this.isAdd = type === "add" ? true : false;
        this.modeTitle = type === "add" ? '新建权限' : '修改权限'
        this.inputDisabled = type === "add" ? false : true
        //查询下拉选择权限的集合
        this.getAllPermissionList(params)
        //初始化form表单数据
        if (params) {
          let formData = {};
          formData.permName = params.permName;
          formData.permCode = params.permCode;
          formData.priority = params.priority;
          formData.path = params.path;
          formData.key = params.parentId.toString()
          this.parentId = params.parentId
          //修改入口，要记录当前课程方的ID
          this.permissionId = params.id;
          setTimeout(() => {
            this.form.setFieldsValue(formData);
          }, 100);
        } else {
          this.form.resetFields();
        }
      },

      //隐藏
      handleCancel() {
        this.visible = false;
        this.$emit("closeForm");
      },

      //提交表单
      handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields((err, value) => {
          //trim去除左右空格
          value.permName = value.permName? value.permName.trim(): ''
          value.permCode = value.permCode?value.permCode.trim(): ''
          value.path =  value.path?value.path.trim(): ''
          //校验通过
          if (!err) {
            let tempValue = analysisAddress(value);
            if (this.isAdd) {
              this.addPermission(tempValue);
            } else {
              tempValue.id = this.permissionId
              tempValue.parentId = value.key
              this.updatePermission(tempValue);
            }
          }
        });
      },

      //新增权限
      addPermission(value) {
        value.parentId = parseInt(value.key)
        value.priority = parseInt(value.priority)
        delete value.key
        var self = this
        permission.addPermission(value).then(res => {
          self.$message.success("新增成功");
          self.handleCancel();
          self.$emit("addPermissione", null);
          //查询下拉选择权限的集合
          self.getAllPermissionList()
        });
      },

      //修改权限
      updatePermission(value) {
        //处理字段
        delete value.key
        permission.updatePermission(value).then(res => {
          this.$message.success("修改成功");
          this.$emit("addPermissione", value);
          this.handleCancel();
        });
      },

      //查询下拉选择全部权限的集合
      getAllPermissionList(params) {
        permission.getAllPermissionList().then(res => {
          if (params && params.id) {
            res.data = this.deleteNode(params.id, res.data)
          }
          this.allPermissionList = res.data;
        })
      },

      //递归查找删除
      deleteNode(paramId, obj) {
        if (typeof obj !== 'object' || obj === null) {
          return obj
        }
        const copy = Array.isArray(obj) ? [] : {};
        Object.keys(obj).forEach(key => {
          if (paramId !== obj[key].id) {
            copy[key] = this.deleteNode(paramId, obj[key])
          }
        })
        return copy;
      }
    },

  };
</script>
<style lang="scss" scoped>
  @import "src/config/var";
</style>